import { handleResponse, handleError } from "./apiUtils";
import * as apiConfig from "./config";
const baseUrl = `${apiConfig.API_URL}postcomment`;


export function getUserPosts(criteria) { 

    var url = `${baseUrl}/getuserposts`;

    return fetch(url, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getNewsFeed(criteria) {

    var url = `${baseUrl}/getusernewsfeed`;

    return fetch(url, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getGroupPosts(criteria) {

    var url = `${baseUrl}/getgroupposts`;

    return fetch(url, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getEventPosts(criteria) {

    var url = `${baseUrl}/geteventposts`;

    return fetch(url, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getPost(postId) {
    var url = `${baseUrl}/${postId}`;

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getPostComments(post) {

    var url = `${baseUrl}/getpostcomments`;

    return fetch(url, {
        method: "POST", body: JSON.stringify(post), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function addPost(post) {

    var url = `${baseUrl}/addpost`;

    return fetch(url, {
        method: "POST", body: JSON.stringify(post), headers: { "content-type": "application/json" }, credentials: "include"
    })
        .then(handleResponse)
        .catch(handleError);
}

export function editPost(post) {

    var url = `${baseUrl}/editpost`;

    return fetch(url, {
        method: "PUT", body: JSON.stringify(post), headers: { "content-type": "application/json" }, credentials: "include"
    })
        .then(handleResponse)
        .catch(handleError);
}

export function deletePost(post) {
    var url = `${baseUrl}/deletepost`;

    return fetch(url, { method: "DELETE", body: JSON.stringify(post), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function addComment(comment) {

    var url = `${baseUrl}/addcomment`;

    return fetch(url, {
        method: "POST", body: JSON.stringify(comment), headers: { "content-type": "application/json" }, credentials: "include"
    })
        .then(handleResponse)
        .catch(handleError);
}

export function editComment(comment) {

    var url = `${baseUrl}/editcomment`;

    return fetch(url, { method: "PUT", body: JSON.stringify(comment), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function deleteComment(comment) {
    var url = `${baseUrl}/deletecomment`;

    return fetch(url, { method: "DELETE", body: JSON.stringify(comment), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function deletePostImage(postId, fileName) {
    var url = `${baseUrl}/deletepostimage/${postId}/${fileName}`;

    return fetch(url, { method: "DELETE", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function deleteCommentImage(commentId, fileName) {
    var url = `${baseUrl}/deletecommentimage/${commentId}/${fileName}`;

    return fetch(url, { method: "DELETE", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}


export function uploadImages(uploadedImages) {
    var url = `${baseUrl}/uploadimages`;

    return fetch(url, {
        method: "POST", body: JSON.stringify(uploadedImages), headers: { "content-type": "application/json" }, credentials: "include"
    })
        .then(handleResponse)
        .catch(handleError);
}

export function react(reaction) {
    return fetch(`${baseUrl}/react`,
        {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(reaction),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function unReact(reaction) {
    return fetch(`${baseUrl}/unreact`,
        {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(reaction),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function changeReaction(reaction) {
    return fetch(`${baseUrl}/changereaction`,
        {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(reaction),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}


// WEBPACK FOOTER //
// ./src/api/postCommentApi.js